import classNames from 'classnames';
import React, { ReactNode } from 'react';
import Col from '../Col';
import Row from '../Row';
import './Empty.scss';

interface EmptyProps {
  cta?: ReactNode;
  direction?: string;
  headline: string;
  strapline: string;
  image: ReactNode;
  searchIsActive?: boolean | string;
}

const Empty = ({
  cta,
  direction,
  headline,
  strapline,
  image,
  searchIsActive,
}: EmptyProps) => (
  <div
    className={classNames('empty', {
      [`empty--${direction}`]: direction,
    })}
  >
    <Row>
      <Col xs="12" md={direction === 'ttb' ? 12 : 5}>
        <div className="empty__headline">
          {searchIsActive ? 'Your search returned no results' : headline}
        </div>
        <div className="empty__strapline">
          {searchIsActive ? 'Consider refining your search.' : strapline}
        </div>
        {searchIsActive ? <div></div> : <div className="empty__cta">{cta}</div>}
      </Col>
      <Col
        xs="12"
        md={direction === 'ttb' ? 12 : 6}
        mdOffset={direction === 'ttb' ? null : 1}
      >
        <div className="empty__image">{image}</div>
      </Col>
    </Row>
  </div>
);

export default Empty;
